Shopify.ProductSwatchs = (function() {
	var config = {
		slider: '.swatch',
        onComplete: null
	};
    return {
    	showSwatchSlider: function(params) {
    		var params = params || {};

    		$.extend(config, params);

    		var slider = config.slider,
                iconArrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"/></svg>';

            if(window.layout == '5'){
                iconArrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" aria-hidden="true" focusable="false" role="presentation"><path d="M 44.988281 13.984375 C 44.726563 13.992188 44.476563 14.101563 44.292969 14.292969 L 25 33.585938 L 5.707031 14.292969 C 5.519531 14.097656 5.261719 13.992188 4.992188 13.988281 C 4.582031 13.992188 4.21875 14.238281 4.0625 14.613281 C 3.910156 14.992188 4 15.421875 4.292969 15.707031 L 24.292969 35.707031 C 24.683594 36.097656 25.316406 36.097656 25.707031 35.707031 L 45.707031 15.707031 C 46.003906 15.421875 46.09375 14.980469 45.9375 14.601563 C 45.777344 14.222656 45.402344 13.976563 44.988281 13.984375 Z"/></svg>';
            }

    		if(slider.length > 0){
    			if(!slider.hasClass('slick-initialized')){
    				slider.slick({
    					mobileFirst: true,
    					adaptiveHeight: true,
    					vertical: false,
                        infinite: false,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: false,
                        nextArrow: '<button type="button" class="slick-arrow slick-next" aria-label="'+ window.accessibility.next_slide +'">' + iconArrow + '</button>',
                        prevArrow: '<button type="button" class="slick-arrow slick-prev" aria-label="'+ window.accessibility.previous_slide +'">' + iconArrow + '</button>',
                        responsive:
                        [
                        	{
                                breakpoint: 1599,
                                settings: {
                                    slidesToShow: 5
                                }
                            },
                            {
                                breakpoint: 550,
                                settings: {
                                    slidesToShow: 4
                                }
                            }
                        ]
    				});
    			}
    		}
    	}
    }
})();